import uuid from "uuid/v4";

export default function roomsReducer(state, action) {
    let next = [...state];
    switch (action.type) {
        case "ADD_LEVEL":
            next.push({ id: uuid(), rooms: [] });
            break;
        case "REMOVE_LEVEL":
            return next.filter((item) => item.id !== action.id);
        case "ADD_ROOM":
            const newRoom = { id: uuid(), type: "room" };
            if (!next.length) return [{ id: uuid(), rooms: [newRoom] }];
            return next.map((level) => {
                if (level.id === action.level) {
                    return {
                        ...level,
                        rooms: [...level.rooms, newRoom],
                    };
                }
                return level;
            });
            break;
        case "REMOVE_ROOM":
            return next.map((level) => {
                return {
                    ...level,
                    rooms: level.rooms.filter((room) => room.id !== action.id),
                };
            });
        case "CHANGE_ROOM":
            return next.map((level) => {
                if (level.id !== action.level) {
                    return level;
                }
                return {
                    ...level,
                    rooms: level.rooms.map((room) => {
                        if (room.id !== action.id) {
                            return room;
                        }
                        return { ...room, ...action.data };
                    }),
                };
            });
        default:
            break;
    }
    return next;
}
